import { Component, OnInit, Input } from '@angular/core';
import { Roles } from 'src/assets/data/roles';

@Component({
  selector: 'valid-user-detail',
  templateUrl: './valid-user-detail.component.html',
  styleUrls: ['./valid-user-detail.component.scss']
})
export class ValidUserDetailComponent implements OnInit {

  constructor() { }

  @Input() user: any = {};
  public panelOpenState: boolean;
  public rolesDD = Roles;

  ngOnInit() {
  }

  public getRoleDisplay(roleCode: string) {
    const role = Roles.find(role => role.value === roleCode);
    return role ? role.name : '';
  }

}
